import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Params } from "@angular/router";
import { AuthUserService } from "@app/auth/services/auth-user.service";
import { FirebaseAuthService } from "@app/auth/services/firebase-auth.service";
import { AuthEffectErrors, AuthErrorCode } from "@app/auth/store/effects/auth.effects";
import { RouterService } from "@app/root-store/router.service";
import { TSLoggingService } from "@app/shared/services/ts-logging.service";
import { emailValid } from "@app/shared/validators";
import { Observable } from "rxjs";
import { filter, tap } from "rxjs/operators";

@Component({
    selector: "app-email-form",
    templateUrl: "./email-form.component.html",
    styleUrls: ["./email-form.component.scss"],
})
export class EmailFormComponent {
    form = this.formBuilder.group({
        email: ["", emailValid],
        password: ["", Validators.required],
    });

    isPending$ = this.authUserService.selectPendingSignInState$().pipe(
        tap(data => {
            if (data) {
                this.form.enable();
            } else {
                this.form.disable();
            }
        })
    );
    public queryParams$: Observable<Params> = this.routerService.getQueryParams().pipe(tap(this.updateForm(this.form)));
    errorMessage$ = this.authUserService.selectSignInError$().pipe(filter(message => message !== "no user"));
    expiredMessage$ = this.authUserService.expiredMessage$.pipe(tap(msg => msg));
    constructor(
        private readonly formBuilder: FormBuilder,
        private readonly firebaseAuth: FirebaseAuthService,
        private readonly tsLoggingService: TSLoggingService,
        private readonly authUserService: AuthUserService,
        private readonly routerService: RouterService
    ) {}

    get fields() {
        return this.form.controls;
    }

    login(form: FormGroup) {
        if (form.valid) {
            const trimEmail = (form.value.email || "").trim();
            const rawBodyContent = {
                [trimEmail]: "login attempt",
            };
            this.tsLoggingService.logNoSessionEventData(null, "user", "ssopgrest", "login", null, rawBodyContent);

            this.firebaseAuth.signInWithEmailAndPassword(trimEmail, form.value.password).catch(e => {
                let error = { message: "A sign in error occurred" };
                if (e.code === AuthErrorCode.invalidCredentials) {
                    error = { message: AuthEffectErrors.invalidCredentials };
                } else if (e.code === AuthErrorCode.tooManyAuthAttempts) {
                    error = { message: AuthEffectErrors.tooManyAuthAttempts };
                }
                return this.authUserService.setSignInFailure(error);
            });
        }
    }

    cancelPending() {
        this.authUserService.clearLoginErrorState();
    }

    private updateForm(form: FormGroup): (params: Params) => void {
        return (params: Params) => {
            if (params?.emailExists === "true") {
                form.patchValue({
                    email: params?.email,
                });
            }
        };
    }
}
